import { render, staticRenderFns } from "./AlertsView.vue?vue&type=template&id=1bf2c830&scoped=true&"
import script from "./AlertsView.vue?vue&type=script&lang=ts&"
export * from "./AlertsView.vue?vue&type=script&lang=ts&"
import style0 from "./AlertsView.vue?vue&type=style&index=0&id=1bf2c830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf2c830",
  null
  
)

export default component.exports